import React from "react";
// @ts-ignore
import Button from "@fdr/atomic-ui/_atoms/Button";
// @ts-ignore
import GeoComplyMap from "@fdr/static-ui/SvgImages/GeoComplyMap";
import GeoComplyErrorDescription from "@fdr/atomic-ui/_molecules/GeoComplyErrorDescription";
import GeoComplyErrorMessages from "@fdr/atomic-ui/_molecules/GeoComplyErrorMessages";
import { MapImageEnum } from "@tvg/ts-types/GeoComply";
import {
  GeoComplyErrorWrapper,
  ScrollableContent,
  Title,
  MapImage,
  ActionsContent
} from "./styled-components";
import { Props } from "./types";

export const GeoComplyError = ({
  qaLabel = "geoComplyError",
  isGenericError,
  title,
  imageType = MapImageEnum.PIN,
  description,
  errorsTitle,
  errorsMessages = [],
  primaryButton,
  secondaryButton,
  onDismiss
}: Props) => (
  <GeoComplyErrorWrapper data-qa-label={qaLabel}>
    <ScrollableContent>
      <Title data-qa-label={`${qaLabel}-title`}>{title}</Title>

      <MapImage data-qa-label={`${qaLabel}-map-image`}>
        <GeoComplyMap isError={imageType === MapImageEnum.ERROR} />
      </MapImage>

      {description && (
        <GeoComplyErrorDescription
          qaLabel={`${qaLabel}-description`}
          {...description}
        />
      )}

      {!isGenericError && errorsMessages.length > 0 && (
        <GeoComplyErrorMessages
          qaLabel={`${qaLabel}-messages`}
          title={errorsTitle}
          messages={errorsMessages}
        />
      )}
    </ScrollableContent>

    <ActionsContent data-qa-label={`${qaLabel}-actions`}>
      {primaryButton && (
        <Button
          type="betting"
          size="big"
          onClick={primaryButton.onClick}
          qaLabel={`${qaLabel}-primary-btn`}
        >
          {primaryButton.title}
        </Button>
      )}

      {secondaryButton && (
        <Button
          type="primary"
          size="big"
          onClick={secondaryButton.onClick}
          qaLabel={`${qaLabel}-secondary-btn`}
        >
          {secondaryButton.title}
        </Button>
      )}

      <Button
        type="fanduel"
        size="big"
        onClick={onDismiss}
        qaLabel={`${qaLabel}-dismiss-btn`}
        borderLess
      >
        Dismiss
      </Button>
    </ActionsContent>
  </GeoComplyErrorWrapper>
);

export default GeoComplyError;
